// extracted by mini-css-extract-plugin
export default {"Loading":"bcy_a bih_a bih_w bih_j bih_ul bih_um bih_fm"};